
define('text!../../public/common/nonLocalized.json',[],function () { return '{\n "products":{\n     "g2m": "GoToMeeting",\n     "g2w" : "GoToWebinar",\n     "g2t": "GoToTraining",\n     "ov":  "OpenVoice"\n  }\n}\n';});

